import { t } from "../../../../i18n";
import { useTheme } from '@mui/material/styles';
import { Box, Button, FormControl, FormHelperText, InputLabel, OutlinedInput, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AnimateButton from '../../../../component/extended/AnimateButton';
import { useForgetPassword } from 'hooks/useAuth';

// ============================|| FIREBASE - LOGIN ||============================ //

function AuthForgetPassword({
  ...others
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const formikForgetPassword = useForgetPassword();
  return <form noValidate onSubmit={formikForgetPassword.handleSubmit} {...others}>
            <FormControl fullWidth error={Boolean(formikForgetPassword.touched.email && formikForgetPassword.errors.email)} sx={{
      ...theme.typography.customInput
    }}>
                <InputLabel htmlFor="outlined-adornment-email-login">{t("Email")}</InputLabel>
                <OutlinedInput id="outlined-adornment-email-login" type="email" value={formikForgetPassword.values.email} name="email" onBlur={formikForgetPassword.handleBlur} onChange={formikForgetPassword.handleChange} label={t("Email")} inputProps={{}} />
                {formikForgetPassword.touched.email && t(formikForgetPassword.errors.email) && <FormHelperText error id="standard-weight-helper-text-email-login">
                            {t(formikForgetPassword.errors.email)}
                        </FormHelperText>}
            </FormControl>

            <Stack direction="row" justifyContent="start" spacing={1}>
                <Typography variant="subtitle1" color="accent.main" sx={{
        textDecoration: 'none',
        cursor: 'pointer'
      }} component="a" onClick={() => navigate('/login', {
        replace: true
      })}>{t("Voltar a início de sessão")}</Typography>
            </Stack>
            {t(formikForgetPassword.errors.submit) && <Box sx={{
      mt: 3
    }}>
                    <FormHelperText error>
                        {t(formikForgetPassword.errors.submit)}
                    </FormHelperText>
                </Box>}

            <Box sx={{
      mt: 2
    }}>
                <AnimateButton>
                    <Button disableElevation disabled={formikForgetPassword.isSubmitting} fullWidth size="large" type="submit" variant="contained" color="secondary" name="submit">{t("Enviar Email")}</Button>
                </AnimateButton>
            </Box>
        </form>;
}
export default AuthForgetPassword;
